<template>
  <div class="home" id="home" name="home">
    <!-- 轮播图 -->
    <div>
      <div>
        <div>
          <!-- <img src="../assets/imgs/uploads/mobile/Rectangle 249.png" style="width: 100vw;height: 140.267vw;" alt=""> -->
          <el-carousel height="140.267vw" arrow="never" :interval="4000" ref="slideCarousel">
            <el-carousel-item v-for="item in carouselList" :key="item.id">
              <router-link :to=item.router>
                <img :src="item.imgUrl" class="medium" alt="">
              </router-link>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div style="width: 75.813vw;height: 27.733vw;margin: 1.333vw auto;">
          <div>
            <router-link to="/exploregigwi"><img src="../assets/imgs/uploads/xin-gigwi.png"
                style="width: 34.4vw;height: 13.6vw; object-fit: contain;" alt=""></router-link>
            <router-link to="/explorepetgeek"><img src="../assets/imgs/uploads/mobile/Group 203.png"
                style="width: 34.4vw;height: 13.6vw;" alt=""></router-link>
          </div>
          <div>
            <router-link to="/exploregp"><img src="../assets/imgs/uploads/mobile/Group 202.png"
                style="width: 34.4vw;height: 13.6vw;" alt=""></router-link>
            <router-link to="/exploreskipdawg"><img src="../assets/imgs/uploads/mobile/Group 204.png"
                style="width: 34.4vw;height: 13.6vw;" alt=""></router-link>
          </div>
        </div>
        <div style="width: 100vw;height: 105.867vw;background-color: #f5f5f5;overflow: hidden;">
          <div
            style="font-weight: bold;display: flex;justify-content: center;font-size: 5.333vw;margin: 9.067vw 0 5.867vw ;">
            Our Brands</div>
          <div style="font-size: 4vw;color: #000;">
            <div style="display: flex;justify-content: center;">Over the decades, we have been dedicated to</div>
            <div style="display: flex;justify-content: center;">a single goal: creating entirely new life</div>
            <div style="display: flex;justify-content: center;">experiences for pet and their parents. Our</div>
            <div style="display: flex;justify-content: center;">brands emphasizsed innovative, safe, and</div>
            <div style="display: flex;justify-content: center;">enjoyable designs, and we continuously create</div>
            <div style="display: flex;justify-content: center;">our products with our perspective, missions</div>
            <div style="display: flex;justify-content: center;">and values, driving forward the industry and</div>
            <div style="display: flex;justify-content: center;">benefiting society.</div>
          </div>
          <div style="margin-top: 12.8vw;display: flex;justify-content: center;">
            <router-link to="/ourbrands"><el-button class="mbexplore">Explore our brands</el-button></router-link>
          </div>
        </div>
        <div class="mbtitle" style="margin: 10.133vw 0 6.267vw;">
          Lastest Video
        </div>
        <div style="display: flex;justify-content: center;border-radius: 3.6vw;">
          <video muted="muted" :src="video.imgUrl" type="video/mp4" controls="controls" loop
            style="width: 84.533vw;height: 47.557vw;border-radius: 3.6vw;">
          </video>
        </div>
        <div class="mbtitle" style="margin: 8.533vw 0 12.267vw;">
          Best Sellers
        </div>
        <div style="width: 100%;">
          <div class="product-container1">
            <div v-for="item in bestSellers" :key="item.id" style="width: 56.779vw;height: 59.733vw;">
              <div :class="item.categoryName == 'DOG' ? 'tg' : 'tt'">{{ item.categoryName }}</div>
              <router-link :to="{ path: '/detail', query: { spuId: item.spuId } }">
                <img v-lazy="item.imgUrl" alt="" style="width: 43.979vw;height: 43.933vw;margin: 3vw 6.4vw;">
              </router-link>
              <div style="margin-top: 3.733vw;font-size: 4.533vw;display: flex;justify-content: center;">
                <p style="font-weight: bold;font-size: 3.2vw;">{{ item.name }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="mbtitle" style="margin: 8.533vw 0 5.793vw;">
          What’s New
        </div>
        <div style="margin-bottom: 12.267vw;">
          <img src="../assets/imgs/uploads/Group 52.png" style="width: 100vw;height: 63.621vw;" alt="">
        </div>
        <div style="width: 100%;">
          <div class="product-container1">
            <div v-for="(item, index) in whatsNews" :key="index" style="width: 56.779vw;height: 59.733vw;">
              <div :class="item.categoryName == 'DOG' ? 'tg' : 'tt'">{{ item.categoryName }}</div>
              <router-link :to="{ path: '/detail', query: { spuId: item.spuId } }">
                <img v-lazy="item.imgUrl" alt="" style="width: 43.979vw;height: 43.933vw;margin: 3vw 6.4vw;">
              </router-link>
              <div style="margin-top: 14px;font-size: 17px;display: flex;justify-content: center;">
                <p style="font-weight: bold;font-size: 12px;">{{ item.name }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="sbc">
          <div class="mbtit">Shop by Catalog</div>
          <div class="mb-image-container">
            <div style="overflow: hidden;border-radius: 2.667vw;">
              <img @click="handleImageClick('left')" :src="leftImageSrc" alt="Left Image"
                style="width: 41.581vw;height: 15.752vw;">
            </div>
            <div style="overflow: hidden;border-radius: 2.667vw;">
              <img @click="handleImageClick('right')" :src="rightImageSrc" alt="Right Image"
                style="width: 41.581vw;height: 15.752vw;">
            </div>
          </div>
          <div style="width: 100%;">
            <div v-if="selectedImage === 'left'" class="mb-dogcategory">
              <div v-for="item in dogcategory" :key="item.id" style="margin: 0 1.987vw;">
                <router-link to="/product">
                 <div style="position: relative;">
                  <div class="mb-bigg">
                    <img :src="item.imgPath" alt="" style="width: 26.8vw;height: 26.8vw;border-radius: 2.667vw;">
                  </div>
                  <div class="mb-label">
                    <div style="max-width: 20.565vw;">{{ item.label }}</div>
                    <div style="max-width: 20.565vw;">{{ item.label1 }}</div>
                  </div>
                </div> 
                </router-link>
              </div>
            </div>
            <div v-else class="mb-dogcategory">
              <div v-for="item in category" :key="item.id" style="margin: 0 1.987vw;">
                <div style="position: relative;">
                  <div class="mb-bigg">
                    <img :src="item.imgPath" alt="" style="width: 26.8vw;height: 26.8vw;border-radius: 2.667vw;">
                  </div>
                  <div class="mb-label">
                    <div style="max-width: 20.565vw;">{{ item.label }}</div>
                    <div style="max-width: 20.565vw;">{{ item.label1 }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mb-Wholesaler">
          <p style="display: flex;justify-content: center;color: #000;font-weight: bold;font-size: 5.333vw;">We Care Our
            Wholesaler</p>
          <div style="width: 92.72vw;margin: 0 auto;">
            <el-carousel :interval="5000" arrow="always" height="120vw">
              <el-carousel-item v-for="item in buttons" :key="item.id">
                <div class="mb-wh-tit">{{ item.text }}</div>
                <div style="display: flex;justify-content: center;">
                  <img :src="item.imageUrl" style="width: 84.672vw;height: 49.856vw;" alt="">
                </div>
                <div style="display: flex;justify-content: center;">
                  <div style="color: #333;font-size: 3.733vw;margin-top: 5.6vw;width: 84.672vw;">
                    {{ item.description }}</div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      selectedImage: 'left', // 默认选中左边图片
      leftImageSrc: require('../assets/imgs/uploads/Group 3181.png'),
      rightImageSrc: require('../assets/imgs/uploads/Group 31.png'),
      skuId: "", // 商品id
      productDetail: "", // 商品详细信息
      carouselList: [],
      startIndex: 0,
      isThrottled: false,
      startIndex1: 0,
      isThrottled1: false,
      carouselHeight: '714px',
      brandList: [
        { id: 1, imgPath: require('../assets/imgs/uploads/xin-gigwi.png'), link: '/exploregigwi' },
        { id: 2, imgPath: require('../assets/imgs/uploads/brand1.png'), link: '/exploregp' },
        { id: 3, imgPath: require('../assets/imgs/uploads/brand3.png'), link: '/explorepetgeek' },
        { id: 4, imgPath: require('../assets/imgs/uploads/brand4.png'), link: '/exploreskipdawg' }
      ],
      dogs: [
        { id: 1, imgPath: require('../assets/imgs/uploads/dog1.jpg'), name: 'Plush Friendz Squirrel', spuId: 190 },
        { id: 2, imgPath: require('../assets/imgs/uploads/dog2.jpg'), name: 'Suppa Puppa Elephant', spuId: 191 },
        { id: 3, imgPath: require('../assets/imgs/uploads/dog3.png'), name: 'Suppa Puppa Dino', spuId: 214 },
        { id: 4, imgPath: require('../assets/imgs/uploads/dog4.jpg'), name: 'Suppa Puppa Racoon', spuId: 217 },
      ],
      bestSellers: [],
      whatsNews: [],
      cats: [
        { id: 1, imgPath: require('../assets/imgs/uploads/cat1.png'), name: 'lion Mat', spuId: 167 },
        { id: 2, imgPath: require('../assets/imgs/uploads/cat2.png'), name: 'Separable mushroom', spuId: 98 },
        { id: 3, imgPath: require('../assets/imgs/uploads/cat3.jpg'), name: 'Fox Silvervine Ring', spuId: 89 },
        { id: 4, imgPath: require('../assets/imgs/uploads/cat4.jpg'), name: "Vibrating Running'Yellow Bee", spuId: 150 },
      ],
      dogcategory: [
        {
          id: 1,
          imgPath: require('../assets/imgs/uploads/2.toy.jpg'),
          label: 'Toys',
          label1: ''
        },
        {
          id: 2,
          imgPath: require('../assets/imgs/uploads/3Collars,Harnesses.jpg'),
          label: 'Accessories',
          label1: ''
        },
        {
          id: 3,
          imgPath: require('../assets/imgs/uploads/4.Feeding & Watering Supplies.jpg'),
          label: 'Supplies',
          label1: ''
        },
        {
          id: 4,
          imgPath: require('../assets/imgs/uploads/5.Beds&pats.jpg'),
          label: 'Beddings',
          label1: '',
        },
        {
          id: 5,
          imgPath: require('../assets/imgs/uploads/1.Grooming.jpg'),
          label: 'Grooming',
          label1: ''
        },
      ],
      category: [
        { id: 1, imgPath: require('../assets/imgs/uploads/cats2.jpg'), label: 'Toys' },
        {
          id: 2,
          imgPath: require('../assets/imgs/uploads/cats3.jpg'),
          label: 'Accessories',
          label1: '',
        },
        { id: 3, imgPath: require('../assets/imgs/uploads/cats4.jpg'), label: 'Supplies', label1: '' },
        {
          id: 4,
          imgPath: require('../assets/imgs/uploads/cats5.jpg'),
          label: 'Beddings',
          label1: '',
        },
        { id: 5, imgPath: require('../assets/imgs/uploads/cats1.jpg'), label: 'Grooming', label1: '' },
      ],
      buttons: [
        {
          id: 1,
          text: 'Our Platform',
          imageUrl: require('../assets/imgs/uploads/onestop.png'),
          description: 'We provide our customers with a one-stop procurement platform, with the most cost-effective products.'
        },
        {
          id: 2,
          text: 'Logistics Services',
          imageUrl: require('../assets/imgs/uploads/logistics.png'),
          description: 'Providing the whole logistic service,no matter container or package.You can choose FOB or CIF freely.We also can deal with all products of import and export ,send goods to your home.'
        },
        {
          id: 3,
          text: 'Marketing Promotion',
          imageUrl: require('../assets/imgs/uploads/market.png'),
          description: "Providing different types of promotional files.Pictures,videos,product's specifications,You can use these it for posting in store,exhibition.Or  upload for online shops."
        },
        {
          id: 4,
          text: 'Upgrade Your Business Experience',
          imageUrl: require('../assets/imgs/uploads/upgrade.png'),
          description: 'We start our business in the pet sector science 1998.Servicing for more than 30 countries more than 25 years.We have enough experience to help our customers.No matter which stage you stand,we are willing to help you start and grow up.'
        },
      ],
      itemdetail: {},
      activeButton: 0,
      video: [],
    }
  },
  created() {
    this.itemdetail = this.buttons[0];
    this.getBestSellers()
    this.getNews()
  },
  activated() {
    if (this.$route.query.skuId != undefined) {
      this.skuId = this.$route.query.skuId;
    }
  },
  mounted() {
    this.$router.afterEach(() => {
      window, scrollTo(0, 0)
    })
    this.getCarousel()
    this.updateCarouselHeight();
    window.addEventListener('resize', this.updateCarouselHeight);
    if (this.$refs.slideCarousel) this.slideBanner()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateCarouselHeight);
  },
  computed: {
    containerStyle() {
      // offset 应该是 startIndex 乘以单个商品的宽度百分比
      const offset = -(this.startIndex * 25); // 因为每个商品宽度占25%
      return {
        transform: `translateX(${offset}%)`,
        transition: 'transform 0.5s ease'
      };
    },
    containerStyle1() {
      // offset 应该是 startIndex 乘以单个商品的宽度百分比
      const offset = -(this.startIndex1 * 25); // 因为每个商品宽度占25%
      return {
        transform: `translateX(${offset}%)`,
        transition: 'transform 0.5s ease'
      };
    },
    // 检查是否到达了最左侧
    disableLeftArrow() {
      return this.startIndex === 0;
    },
    // 检查是否到达了最右侧
    disableRightArrow() {
      return this.startIndex >= this.bestSellers.length - 4;
    },
    disableLeftArrow1() {
      return this.startIndex1 === 0;
    },
    disableRightArrow1() {
      return this.startIndex1 >= this.whatsNews.length - 4;
    }
  },
  methods: {
    ...mapActions(["unshiftShoppingCart", "addShoppingCartNum"]),
    // 获取商品详细信息
    carouselChange: function (key1) {
      this.activeButton = key1
      this.itemdetail = this.buttons[key1];
    },
    changeActiveButton(index) {
      this.activeButton = index;
      this.itemdetail = this.buttons[index];
    },
    getBestSellers() {
      this.$axios
        .post("/api/mall/home/getBestSellers")
        .then(res => {
          if (res.data.code === 200) {
            this.bestSellers = res.data.data
          } else {
            this.notifyError(res.data.message);
          }
        })
        .catch(err => {
          return Promise.reject(err);
        });
    },
    getNews() {
      this.$axios
        .post("/api/mall/home/getNew")
        .then(res => {
          if (res.data.code === 200) {
            this.whatsNews = res.data.data
          } else {
            this.notifyError(res.data.message);
          }
        })
        .catch(err => {
          return Promise.reject(err);
        });
    },
    handleImageClick(side) {
      if (side === 'left') {
        this.leftImageSrc = require('../assets/imgs/uploads/Group 3181.png');
        this.rightImageSrc = require('../assets/imgs/uploads/Group 31.png');
      } else {
        this.leftImageSrc = require('../assets/imgs/uploads/Group 318.png');
        this.rightImageSrc = require('../assets/imgs/uploads/Group 311.png');
      }
      this.selectedImage = side;
    },
    getCarousel() {
      this.$axios
        .post("/api/mall/home/getMobileData")
        .then(res => {
          if (res.data.code === 200) {
            this.carouselList = res.data.data.image
            this.video = res.data.data.video[0]
          } else {
            this.notifyError(res.data.message);
          }
        })
        .catch(err => {
          return Promise.reject(err);
        });
    },
    scrollLeft() {
      if (this.disableLeftArrow) return;
      this.throttle();
      this.startIndex -= 1;
    },
    scrollRight() {
      if (this.disableRightArrow) return;
      this.throttle();
      this.startIndex += 1;
    },
    throttle() {
      if (this.isThrottled) return;
      this.isThrottled = true;
      setTimeout(() => (this.isThrottled = false), 500);
    },
    scrollLeft1() {
      if (this.disableLeftArrow1) return;
      this.throttle1();
      this.startIndex1 -= 1;
    },
    scrollRight1() {
      if (this.disableRightArrow1) return;
      this.throttle1();
      this.startIndex1 += 1;
    },
    throttle1() {
      if (this.isThrottled1) return;
      this.isThrottled1 = true;
      setTimeout(() => (this.isThrottled1 = false), 500);
    },
    updateCarouselHeight() {
      if (window.innerWidth < 1268) {
        this.carouselHeight = '472px';
      } else if (window.innerWidth < 1600) {
        this.carouselHeight = '550px';
      } else if (window.innerWidth < 1920) {
        this.carouselHeight = '600px';
      } else if (window.innerWidth > 2100 && window.innerWidth < 2300) {
        this.carouselHeight = '786px';
      } else if (window.innerWidth > 2300) {
        this.carouselHeight = '885px';
      } else {
        this.carouselHeight = '714px';
      }
    },
    slideBanner() {
      //选中的轮播图
      var box = document.querySelector('.el-carousel__container');
      var startPoint = 0;
      var stopPoint = 0;
      //重置坐标
      var resetPoint = function () {
        startPoint = 0;
        stopPoint = 0;
      }
      //手指按下
      box.addEventListener("touchstart", function (e) {
        //手指点击位置的X坐标
        startPoint = e.changedTouches[0].pageX;
      });
      //手指滑动
      box.addEventListener("touchmove", function (e) {
        //手指滑动后终点位置X的坐标
        stopPoint = e.changedTouches[0].pageX;
      });
      //当手指抬起的时候，判断图片滚动离左右的距离
      let that = this
      box.addEventListener("touchend", function () {
        if (stopPoint == 0 || startPoint - stopPoint == 0) {
          resetPoint();
          return;
        }
        if (startPoint - stopPoint > 0) {
          resetPoint();
          that.$refs.slideCarousel.next();
          return;
        }
        if (startPoint - stopPoint < 0) {
          resetPoint();
          that.$refs.slideCarousel.prev();
          return;
        }
      });
    },
  }
};
</script>
<style scoped>
/* 轮播图CSS */
.home {
  font-size: 16px;
}

.product-slider {
  width: 1280px;
  overflow: hidden;
  position: relative;
}

.product-slider1 {
  cursor: pointer;
  width: 1280px;
  overflow: hidden;
  position: relative;
}

.product-slider:hover .leftarrow {
  display: block;
}

.product-slider:hover .rightarrow {
  display: block;
}

.leftarrow {
  display: none;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 5;
}

.rightarrow {
  display: none;
  position: absolute;
  top: 50%;
  right: 0%;
  transform: translateY(-50%);
  z-index: 5;
}

.product-slider1:hover .leftarrow1 {
  display: block;
}

.product-slider1:hover .rightarrow1 {
  display: block;
}

.leftarrow1 {
  display: none;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 5;
}

.rightarrow1 {
  display: none;
  position: absolute;
  top: 50%;
  right: 0%;
  transform: translateY(-50%);
  z-index: 5;
}

.product-window {
  overflow: hidden;
}

.product-container {
  display: flex;
  /* 提升性能 */
}

.isable {
  pointer-events: none;
  display: none !important;
}

.block {
  width: 100%;
}

/* 轮播图CSS END */
.wrapper {
  width: 1280px;
  margin: 0 auto;
}

.wholesaler {
  margin-bottom: 64px;
}

::v-deep .el-carousel__arrow {
  z-index: 5;
}

::v-deep .el-carousel__arrow--left {
  width: 30px;
  height: 30px;
  font-size: 20px;
}

::v-deep .el-carousel__arrow--left:hover {
  background-color: #d86568;
}

::v-deep .el-carousel__arrow--right {
  width: 30px;
  height: 30px;
  font-size: 20px;
}

::v-deep .el-carousel__arrow--right:hover {
  background-color: #d86568;
}

::v-deep .wholesaler .el-carousel__arrow {
  width: 40px;
  height: 40px;
  font-size: 30px;
  font-weight: bold;
  color: #000;
  background-color: #fff;
}

/* 子盒子，设置为： */

.hover-image {
  display: none;
}


.el-main {
  margin: 0 !important;
}

.brand {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 28px 0;
}

.vpi {
  height: 380px;
  width: 230px;
  padding: 10px;
  border: 3px solid #808080;
  border-radius: 30px;
}

.vpi:hover {
  border: 3px solid #d86568;
}

.custom-divider {
  border: 2px solid #f09285;
  /* 设置粗细和颜色 */
}

.btn {
  width: 314px;
  height: 64px;
  margin: 0;
  border: none;
  border-radius: 15px;
  background-color: #EAEAEA;
  display: block;
}

.brands {
  width: 236px;
  height: 53px;
  background-color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
}

.active {
  background-color: #333;
  color: #fff;
}

.area {
  display: flex;
  align-items: center;
  margin-top: 83px;
  width: 1140px;
  height: 348px;
}

.image {
  flex: 1;
}

.text {
  flex: 2;
  padding-left: 83px;
}

.image img {
  width: 591px;
  height: 348px;
}

.tg {
  font-size: 9px;
  font-weight: bold;
  width: 36px;
  height: 18px;
  text-align: center;
  line-height: 18px;
  background-color: #C6A4FF;
  color: #fff;
  border-radius: 38px;
}

.tt {
  font-size: 9px;
  font-weight: bold;
  width: 36px;
  height: 18px;
  text-align: center;
  line-height: 18px;
  background-color: #95C0FF;
  color: #fff;
  border-radius: 38px;
}

.campaign {
  height: 292px;
  margin-bottom: 90px;
}

.image-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 63px;
}

.imghandle:hover img {
  transform: scale(1.1);
  transition: all .5s linear !important;
}

.label {
  position: absolute;
  bottom: 7%;
  left: 50%;
  color: #FFF;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  transform: translateX(-50%);
}

.bigg {
  border-radius: 20px;
  overflow: hidden;
}

.bigg:hover img {
  transform: scale(1.3)
}

::v-deep .el-carousel__container {
  height: 348px;
}

.rounded-image {
  width: 591px;
  height: 348px;
  margin-left: 100px;
  object-fit: cover;
}


/* 移动端 */
.mbexplore {
  width: 47.347vw;
  height: 12vw;
  border: none;
  font-size: 4vw;
  font-weight: bold;
  background-color: #000;
  color: #FFF;
}

.mbtitle {
  display: flex;
  justify-content: center;
  color: #303030;
  font-weight: bold;
  font-size: 6.133vw;
}

.product-container1 {
  display: flex;
  overflow-x: scroll;
  height: 68.733vw;
  overflow-y: hidden;
}

.product-container1::-webkit-scrollbar {
  display: none;
}

.sbc {
  background-color: #F8F8F8;
  height: 83.733vw;
  margin-top: 5.6vw;
  overflow: hidden;
}

.mbtit {
  margin: 9.067vw 0 5.867vw;
  color: #303030;
  font-size: 5.333vw;
  font-weight: bold;
  display: flex;
  justify-content: center;
}

.mb-image-container {
  display: flex;
  justify-content: space-between;
  margin: 0 7.733vw 4.515vw;
}

.mb-bigg {
  border-radius: 2.667vw;
  overflow: hidden;
}

.mb-label {
  position: absolute;
  bottom: 7%;
  left: 50%;
  color: #FFF;
  font-size: 3.2vw;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  transform: translateX(-50%);
}

.mb-dogcategory {
  display: flex;
  overflow-x: scroll;
  overflow-y: hidden;
}

.mb-dogcategory::-webkit-scrollbar {
  display: none;
}

.medium {
  width: 375px;
  height: 526px;
}

.mb-Wholesaler {
  height: 145vw;
  padding: 11.467vw 3.733vw 0;
}

.mb-wh-tit {
  width: 84.533vw;
  height: 17.229vw;
  color: #FFF;
  font-size: 4.267vw;
  font-weight: bold;
  background-color: #333;
  border-radius: 2.667vw;
  margin: 8.267vw auto 4.405vw;
  display: flex;
  justify-content: center;
  align-items: center;
}

::v-deep .mb-Wholesaler .el-carousel__arrow--left {
  background-color: transparent;
  color: #000;
  left: -2.133vw;
}

::v-deep .mb-Wholesaler .el-carousel__arrow--left:hover {
  background-color: transparent;
}

::v-deep .mb-Wholesaler .el-carousel__arrow--right {
  background-color: transparent;
  color: #000;
  right: -2.133vw;
}

::v-deep .mb-Wholesaler [class^=el-icon-] {
  font-weight: bold;
}

::v-deep .mb-Wholesaler .el-carousel__arrow--right:hover {
  background-color: transparent;
}
</style>